export interface EmptyElement {
  metric: string;
  stage: string;
  relativeToLastYear: string;
  enteringClassYear: number;
  summary: string;
  note: string;
  details: unknown[];
}

export const EMPTY_ELEMENT: EmptyElement = {
  metric: '',
  stage: '',
  relativeToLastYear: 'Increase',
  enteringClassYear: new Date().getFullYear(),
  summary: '',
  note: '',
  details: [],
};
